<template>
  <dl v-for="el in list" :key="el.start" class="entry-wrapper">
    <dt class="entry-time">
      <a @click.stop.prevent="store.setVideoTime(el.start)" href="#" :data-testid="`viewer-transcription-at-${el.start}`" class="entry-time-link">
        {{ secsToHuman(el.start) }}
      </a>
    </dt>
    <TranscriptionEdit v-if="editing" :transcription="el" />
    <dd data-testid="transcription-list-item" v-else>
      <p class="dark:text-zinc-300">{{ el.words }}</p>
    </dd>
  </dl>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import TranscriptionEdit from './TranscriptionEdit.vue';

withDefaults(
  defineProps<{
    editing?: boolean;
  }>(),
  {
    editing: false,
  }
);
const store = useViewerItemStore();
const { transcriptionData: list } = storeToRefs(useTranscriptionStore());

const secsToHuman = (secs: number) => {
  const t = secs % 3600;
  const m = Math.floor(t / 60);
  const s = Math.floor(t % 60);

  return `${m.toLocaleString('en-US', { minimumIntegerDigits: 2 })}:${s.toLocaleString('en-US', { minimumIntegerDigits: 2 })}`;
};
</script>
<style scoped>
.entry-wrapper {
  @apply relative flex gap-8 text-base;
}

.entry-time {
  @apply text-slate-600 dark:text-zinc-400 w-max;
}
.entry-time-link {
  @apply relative hover:after:content-['→'] hover:text-blue-600 after:absolute rounded focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none;
}
</style>
